import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Mail } from "lucide-react";

const STATUSES = ["Yeni", "Okundu", "Yanıtlandı"];
const STATUS_STYLE = {
  Yeni: "bg-[#D4AF37]/15 text-[#8a6d00]",
  Okundu: "bg-[#40916C]/15 text-[#2D6A4F]",
  Yanıtlandı: "bg-[#1B4D2E]/15 text-[#1B4D2E]",
};

export default function MessagesTab() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/contact-messages").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    setItems((arr) => arr.map((m) => (m.id === id ? { ...m, status } : m)));
    try { await api.patch(`/admin/contact-messages/${id}`, { status }); } catch { toast.error("Güncellenemedi."); }
  };

  const remove = async (id) => {
    try { await api.delete(`/admin/contact-messages/${id}`); setItems((a) => a.filter((m) => m.id !== id)); toast.success("Silindi."); } catch { toast.error("Silinemedi."); }
  };

  if (!items.length) return <EmptyState />;

  return (
    <div className="space-y-4">
      {items.map((m, i) => (
        <div key={m.id} data-testid={`message-item-${i}`} className="rounded-2xl border border-[#E2E8E4] bg-white p-5">
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div>
              <p className="font-semibold text-[#1A251E]">{m.name}</p>
              <p className="text-sm text-[#40916C]">{m.email}</p>
            </div>
            <div className="flex items-center gap-2">
              <select value={m.status} onChange={(e) => setStatus(m.id, e.target.value)} data-testid={`message-status-${i}`} className={`rounded-full px-3 py-1.5 text-xs font-semibold border-0 ${STATUS_STYLE[m.status] || ""}`}>
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
              <button onClick={() => remove(m.id)} className="grid place-items-center h-8 w-8 rounded-full text-red-600 hover:bg-red-50"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
          <p className="mt-3 text-[#37473d] text-sm leading-relaxed border-t border-[#E2E8E4] pt-3">{m.message}</p>
          <p className="mt-2 font-mono-accent text-[11px] text-[#9aa89f]">{new Date(m.created_at).toLocaleString("tr-TR")}</p>
        </div>
      ))}
    </div>
  );
}

function EmptyState() {
  return (
    <div className="rounded-2xl border border-dashed border-[#E2E8E4] bg-white py-16 text-center">
      <Mail className="h-10 w-10 text-[#E2E8E4] mx-auto" />
      <p className="text-[#5C6F62] mt-3">Henüz iletişim mesajı yok.</p>
    </div>
  );
}
